import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import ToastMessage from "../../components/toast";
import axios from "axios";
import Loader from "../../components/loader"

const CountersTEReport = props => {

    const [loading, setLoading] = useState(false);

    async function getReport() {
        let { company } = props.UserReducer;
        try {
            const response = await axios.get(`api/counters-te/counters-with-time-entries`, {
                params: { companyShortName: company },
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            ToastMessage(error.message, "error");
            setLoading(false);
        };
    };

    return (
        <div>
            <h1>Counters with Time Entries Report</h1>
            <button
                className="btn btn-primary"
                disabled={loading}
                onClick={async () => {
                    setLoading(true);
                    const reportData = await getReport();
                    if (reportData) {
                        const url = window.URL.createObjectURL(new Blob([reportData]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `counters_time_entries_${new Date().toLocaleDateString().replaceAll("/", "_")}.csv`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setLoading(false);
                    }
                }}>
                {loading ? 'Preparing Report...' : 'Download Report'}
            </button>
            {loading && <Loader />}
        </div>
    );
};

const mapStateToProps = ({ UserReducer }) => ({ UserReducer });

export default connect(mapStateToProps, {})(CountersTEReport);